import axios from "./axios"

/**
 * onMpayNotify
 * @param {*} paymentId 
 * @param {*} body 
 */
const onMpayNotify = (paymentId, body) => {
    return axios.post(`/public/api/v1/payment/${paymentId}/mpay/notify`, body).then(res => res.data)
}

/**
 * onMpayReturn
 * @param {*} paymentId 
 */
const onMpayReturn = paymentId => {
    return axios.get(`/public/api/v1/payment/${paymentId}/mpay/return`).then(res => res.data)
}

/**
 * onMpayStart
 * @param {*} paymentId 
 */
const onMpayStart = paymentId => {
    return axios.get(`/public/api/v1/payment/${paymentId}/mpay/start`).then(res => res.data)
}


/**
 * detail
 * @param {*} transactionNo 
 */
const detail = transactionNo => {
    return axios.get(`/public/api/v1/payment/detail/${transactionNo}`).then(res => res.data)
}

export default {
    onMpayNotify,
    onMpayReturn,
    onMpayStart,
    detail
}